// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"77675742","444":"a0f501f1","534":"848f6ac0","627":"0168fad7"}[chunkId] + ".chunk.js";
};